import { useRef } from "react";
import { Camera, X } from "lucide-react";
import { toast } from "sonner";

const PhotoPicker = ({ files, onChange, labels }) => {
  const inputRef = useRef(null);

  const add = (e) => {
    const picked = Array.from(e.target.files || []);
    const next = [...files, ...picked].slice(0, 5);
    if (files.length + picked.length > 5) toast.error(labels.photosMax);
    onChange(next);
    e.target.value = "";
  };

  const remove = (i) => onChange(files.filter((_, idx) => idx !== i));

  return (
    <div data-testid="photo-picker">
      <p className="mb-3 text-xs text-brand-hover">{labels.photosHint}</p>
      <div className="flex flex-wrap gap-3">
        {files.map((f, i) => (
          <div key={i} className="relative h-20 w-20 overflow-hidden rounded-xl border border-brand/20 bg-mint" data-testid={`photo-preview-${i}`}>
            <img src={URL.createObjectURL(f)} alt="" className="h-full w-full object-cover" />
            <button
              type="button"
              onClick={() => remove(i)}
              data-testid={`photo-remove-${i}`}
              className="absolute right-1 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-gold text-white"
              aria-label="Retirer"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
        {files.length < 5 && (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            data-testid="photo-add-button"
            className="flex h-20 w-20 flex-col items-center justify-center gap-1 rounded-xl border-2 border-dashed border-brand/30 text-brand transition-colors hover:border-gold hover:bg-cream hover:text-gold"
          >
            <Camera className="h-5 w-5" />
            <span className="font-mono text-[10px]">{files.length}/5</span>
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={add} className="hidden" data-testid="quote-form-photos-input" />
    </div>
  );
};

export default PhotoPicker;
